import {BrowseCourseWithInstructorDetails} from '@/types/course';
import {TrackableDiscoveryItem} from '@udemy-v2/react-browse-event-tracking';
import {useCourseWithInstructorDetailsContext} from '@/features/course-landing-page/context/course-with-instructor-details-provider.react-component';

/**
 * Returns the more courses by instructor for the given instructor id.
 * @returns The more courses by instructor for the given instructor id.
 */
export const useMoreCoursesByInstructor = (): Record<
    string,
    TrackableDiscoveryItem<BrowseCourseWithInstructorDetails>[]
> => {
    const context = useCourseWithInstructorDetailsContext();
    return context.moreCoursesByInstructor;
};
